import { logger } from '../../../utils/common/logger'
import { DOMEvents, DOMUtils } from '../../../utils/dom'
// importing this way uses loader's built-in style adding mechanism:
import './styles/auth-input.scss' // tslint:disable-line: no-import-side-effect

interface IWindow extends Window {
    htmx: any
}
declare let window: IWindow

export class AuthInput {
    private static DOM = {
        class: {
            button: 'button',
            buttonText: 'button__text',
            buttonWrapper: 'auth-input-edit-button-container',
        }
    }

    public static async initDOM(
        authInputSelector: string, prefillEmail: string, editLinkUrl: string, clickEventName: string
    ) {
        const container = document.querySelector(`${authInputSelector}`)
        const emailInput: HTMLInputElement = container.querySelector('[type=email]')

        if (emailInput) {
            try {
                if (prefillEmail) {
                    // Make the email field readonly and set its value to the prefillEmail
                    emailInput.value = prefillEmail
                    emailInput.readOnly = true
                    emailInput.tabIndex = -1
                    emailInput.classList.add('readonly-input')

                    // Add "Edit" button
                    const mod = await import('./templates/auth-input-edit-button/auth-input-edit-button.htm')
                    const authInputEditButton = mod.default
                    const buttonWrapper = document.createElement('div') as HTMLElement
                    DOMUtils.addClass(buttonWrapper, this.DOM.class.buttonWrapper)
                    buttonWrapper.innerHTML = authInputEditButton
                    const button = buttonWrapper.querySelector('button')
                    button.setAttribute('hx-get', editLinkUrl)

                    button.addEventListener(DOMEvents.click, () => {
                        // track click event
                        const buttonClicked = new Event(clickEventName, {bubbles: true})
                        button.dispatchEvent(buttonClicked)
                    })

                    // The new element contains htmx tags so we need to tell htmx to process it.
                    // Ref. https://htmx.org/docs/#3rd-party
                    window.htmx.process(buttonWrapper)
                    emailInput.after(buttonWrapper)
                }
            } catch (e) {
                logger('error', 'Unable to load show password button UI', e)
            }
        }
    }
}
